import {IMessageState} from './types';
import {Action, Selector, State, StateContext} from '@ngxs/store';
import {Injectable} from '@angular/core';
import {MessagesService} from './service';
import {
    SetSelectedConversation,
    SetSelectedCompany,
    SetSelectedRole,
    SetSelectedWorker,
    FetchUnreadConversations,
    ReduceUnreadConversations,
    FetchLastConversations
} from './actions';
import {tap} from 'rxjs/operators';

const defaults: IMessageState = {
    selectedConversation: null,
    selectedCompany: null,
    selectedRole: null,
    selectedWorker: null,
    unreadConversations: null,
    lastConversations: null
};

@State<IMessageState>({
    name: 'message',
    defaults
})

@Injectable()
export class MessageState {

    @Selector()
    static selectedConversation(state: IMessageState) {
        return state.selectedConversation;
    }

    @Selector()
    static selectedCompany(state: IMessageState) {
        return state.selectedCompany;
    }

    @Selector()
    static selectedRole(state: IMessageState) {
        return state.selectedRole;
    }

    @Selector()
    static selectedWorker(state: IMessageState) {
        return state.selectedWorker;
    }

    @Selector()
    static unreadConversations(state: IMessageState) {
        return state.unreadConversations;
    }

    @Selector()
    static lastConversations(state: IMessageState) {
        return state.lastConversations;
    }

    constructor(private messagesService: MessagesService) {
    }

    @Action(SetSelectedConversation)
    SetSelectedConversation(ctx: StateContext<IMessageState>, action: SetSelectedConversation) {
        ctx.patchState({selectedConversation: action.conversation});
    }

    @Action(SetSelectedCompany)
    SetSelectedCompany(ctx: StateContext<IMessageState>, action: SetSelectedCompany) {
        ctx.patchState({selectedCompany: action.company});
    }

    @Action(SetSelectedRole)
    SetSelectedRole(ctx: StateContext<IMessageState>, action: SetSelectedRole) {
        ctx.patchState({selectedRole: action.role});
    }

    @Action(SetSelectedWorker)
    SetSelectedWorker(ctx: StateContext<IMessageState>, action: SetSelectedWorker) {
        ctx.patchState({selectedWorker: action.worker});
    }

    @Action(FetchUnreadConversations)
    FetchUnreadConversations(ctx: StateContext<IMessageState>, action: FetchUnreadConversations) {
        return this.messagesService.getUnreadConversations()
            .pipe(tap(response => ctx.patchState({unreadConversations: response.unreadConversations})));
    }

    @Action(ReduceUnreadConversations)
    ReduceUnreadConversations(ctx: StateContext<IMessageState>, action: ReduceUnreadConversations) {
        ctx.patchState({unreadConversations: ctx.getState().unreadConversations - 1});
    }

    @Action(FetchLastConversations)
    FetchLastConversations(ctx: StateContext<IMessageState>, action: FetchLastConversations) {
        return this.messagesService.fetchConversations({results: 10, page: 1, type: 'public'}).pipe(tap(response => {
            ctx.patchState({lastConversations: response.results});
        }));
    }

}
